import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "sortAlphaBtn", "sortCountBtn", "hiddenCount", "availableCount"];

  connect() {
    const sort = parseInt(localStorage.getItem('category_sort') || '0');
    if (sort === 1) {
      this.#sortItems((a, b) => (parseInt(b.dataset.count) - parseInt(a.dataset.count)) || a.dataset.name.localeCompare(b.dataset.name));
      this.#setActiveSort(this.sortCountBtnTarget);
    } else {
      this.#setActiveSort(this.sortAlphaBtnTarget);
    }
  }

  sortAlpha() {
    this.#sortItems((a, b) => a.dataset.name.localeCompare(b.dataset.name));
    this.#setActiveSort(this.sortAlphaBtnTarget);
    this.#saveSort(0);
  }

  sortCount() {
    this.#sortItems((a, b) => (parseInt(b.dataset.count) - parseInt(a.dataset.count)) || a.dataset.name.localeCompare(b.dataset.name));
    this.#setActiveSort(this.sortCountBtnTarget);
    this.#saveSort(1);
  }

  #sortItems(compareFn) {
    const list = this.listTarget;
    Array.from(list.children).sort(compareFn).forEach(item => list.appendChild(item));
  }

  #setActiveSort(activeBtn) {
    [this.sortAlphaBtnTarget, this.sortCountBtnTarget].forEach(btn => btn.classList.remove("active"));
    activeBtn.classList.add("active");
  }

  #saveSort(value) {
    localStorage.setItem('category_sort', value);
  }

  toggle(event) {
    const checkbox = event.target;
    const categoryId = event.params.id;
    const wasChecked = checkbox.checked;

    checkbox.disabled = true;

    fetch(`/categories/toggle/${categoryId}`, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
      })
      .then((data) => {
        checkbox.checked = data.selected;
        this.#updateVisibilityCounts(data.hidden_count, data.available_count);
      })
      .catch(() => {
        checkbox.checked = !wasChecked;
      })
      .finally(() => {
        checkbox.disabled = false;
      });
  }

  #updateVisibilityCounts(hidden, available) {
    if (hidden !== undefined && hidden !== null && this.hasHiddenCountTarget) {
      this.hiddenCountTarget.textContent = hidden.toLocaleString();
    }
    if (available !== undefined && available !== null && this.hasAvailableCountTarget) {
      this.availableCountTarget.textContent = available.toLocaleString();
    }
  }
}
